// @flow
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { ErrorsType, UserFormType } from "../types/UserFormType";
import type { DispatchType } from "../../global/types/redux";
import { ErrosDisplay } from "../containers/ErrosDisplay";
import { SingleTextField, SubmitButton } from "imagus-components";
import { CopyRight } from "../../global/components/CopyRight";
import { IsLocalUrl } from "../../global/functions/LocalRedirect";
import { userLogin } from "../actions/profileActions";
import WhiteLogoImage from "../../../images/VixVizion.svg";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import PersonIcon from "@material-ui/icons/Person";

const initialUserform: UserFormType = {
  errors: {},
  loading: false,
  email: "",
  password: "",
  passwordDisplay: false
};

class LoginForm extends Component<*, UserFormType> {
  constructor(props) {
    super(props);
    this.signin = this.signin.bind(this);
    this.switchPassword = this.switchPassword.bind(this);
    this.state = initialUserform;
  }

  switchPassword = (e: Event): * => {
    this.setState({
      passwordDisplay: !this.state.passwordDisplay
    });
  };

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState((state: UserFormType) => ({
      [name]: value
    }));

    this.setState((): * => ({ errors: {} }));
  };

  signin = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();

    this.setState((): * => ({ loading: true }));
    this.props.actions.userLogin(
      this.state.email.trim(),
      this.state.password.trim(),
      (): * => {
        const paramsString = this.props.location.search;
        var searchParams = new URLSearchParams(paramsString);

        if (searchParams.has("next")) {
          const next = searchParams.get("next");
          if (IsLocalUrl(next)) {
            window.location.href = next;
          } else {
            window.location.href = "/account/profile";
          }
        } else {
          window.location.href = "/account/profile";
        }
      },
      (errors: ErrorsType): * => {
        this.setState((state: UserFormType): * => ({
          errors: errors,
          loading: false
        }));
      }
    );
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;

    return (
      <div className="wrapper">
        {this.props.location.pathname === "/logoff" && (
          <AppBar position="static" color="primary">
            <Toolbar>
              <LockOutlinedIcon />
              <Typography
                variant="h6"
                color="inherit"
                className="white-title form-text"
              >
                You have successfully logged out.
              </Typography>
            </Toolbar>
          </AppBar>
        )}
        <img
          src={WhiteLogoImage}
          className="form-logo"
          style={{ float: "right" }}
        />
        <div style={{ clear: "both" }}></div>

        <div className="form-text">
          <Typography
            variant="h5"
            className="green-title"
            style={{ marginBottom: "30px" }}
          >
            Login to your Imagus account
          </Typography>
        </div>
        <form onSubmit={(!loading && this.signin) || undefined}>
          <Grid container spacing={8}>
            <Grid item xs={1} className="icon-block">
              <PersonIcon className="green-icon medium-icon" />
            </Grid>
            <Grid item xs={11}>
              <SingleTextField
                isRequired={true}
                label="Email"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
                inpuType="text"
                isInvalid={errors.email !== undefined}
              />
            </Grid>
            <Grid item xs={1} className="icon-block">
              <LockOutlinedIcon className="green-icon" />
            </Grid>
            <Grid item xs={11} style={{ position: "relative" }}>
              <SingleTextField
                isRequired={true}
                label="Password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
                inpuType={this.state.passwordDisplay ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      className="green-icon"
                      onClick={this.switchPassword}
                    >
                      {this.state.passwordDisplay ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <ErrosDisplay errors={errors} form="signin" />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: "30px" }}>
              <div className="form-btn-block">
                <SubmitButton
                  loading={loading}
                  title="Login"
                  fullWidth
                  isMainButton
                  disabled={Object.keys(errors).length > 0}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className="green-title form-text"
                style={{ marginBottom: "2%" }}
              >
                <span className="form-hint">Forgot Your Password?</span>
                <Link to="/forgot" className="form-link-green">
                  Reset Here
                </Link>
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginBottom: "2%" }}>
              <Divider light />
            </Grid>
            {!process.env.NODE_ENV ||
              (process.env.NODE_ENV === "development" && (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className="green-title form-text"
                  >
                    <span className="form-hint">
                      Haven't got an account or Licence?
                    </span>
                    <span
                      onClick={() => this.props.changePage()}
                      className="form-link-green"
                    >
                      Signup Here
                    </span>
                  </Typography>
                </Grid>
              ))}
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className="green-title form-text fixed-bottom"
              >
                <span className="">{CopyRight}</span>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ userLogin }, dispatch)
});

export default connect(null, mapDispatchToProps)(withRouter(LoginForm));
